<template>
  <div class="container">
    <div class="main">
      <div class="title">职位亮点</div>
      <div class="details row">
        <div class="box col-lg-4 col-md-12 col-sm-12 col-12" v-for="(item, index) in details" :key="index">
          <div class="d-none d-lg-block">
            <div class="conditions">
              <div class="icon"></div>
              <p v-for="(part, index) in item.conditions" :key="index">{{ part.num }}</p>
            </div>
          </div>
          <div class="d-lg-none">
            <div class="conditions">
              <template v-if="item.order === '03'">
                <p>与大牛共事，技术氛围浓厚</p>
                <p>扁平化管理，弹性工作制</p>
                <p>开放的职位发展空间</p>
              </template>
              <template v-else>
                <div class="icon"></div>
                <p v-for="(part, index) in item.conditions" :key="index">{{ part.num }}</p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "JobHighlights",
    data() {
      return {
        details: [
          {
            order: "01",
            conditions: [
              { num: "具有竞争力的薪资条件" },
              { num: "五险一金+年终奖" },
              { num: "弹性的工作时间" },
              { num: "完善的社会保障+住房公积金" },
            ],
          },
          {
            order: "02",
            conditions: [
              { num: "整洁宽敞的办公环境" },
              { num: "全天候零食" },
              { num: "让你可以轻松高效的工作" },
              { num: "丰富多彩的团建活动和节日问候" },
            ],
          },
          {
            order: "03",
            conditions: [
              { num: "与大牛共事" },
              { num: "技术氛围浓厚" },
              { num: "扁平化管理，弹性工作制" },
              { num: "开放的职位发展空间" },
            ],
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import "./join.scss";

  .main {
    .title {
      @extend %title;
    }
  }

  .details {
    .box {
      margin-top: 4.5%;

      .conditions {
        padding: 11% 0;
        height: 100%;
        border-radius: 14px;
        background: rgba(245, 245, 247, 1);
        color: #333;
        font-size: 20px;
        line-height: 36px;

        @extend .flex-center-column;

        div.icon {
          margin-bottom: 24px;
          width: 58px;
          height: 58px;
          background-repeat: no-repeat;
          background-size: 100%;
        }

        &:hover {
          background: rgba(8, 198, 173, 1);
          color: #fff;
          transform: scale(1.1);
          transition: transform linear 0.2s;
        }
      }

      &:nth-of-type(1) {
        .conditions {
          div.icon {
            background-image: url("~assets/img/joinus/post1.png");
          }

          &:hover {
            div.icon {
              background-image: url("~assets/img/joinus/post1-hover.png");
            }
          }
        }
      }

      &:nth-of-type(2) {
        .conditions {
          div.icon {
            background-image: url("~assets/img/joinus/post2.png");
          }

          &:hover {
            div.icon {
              background-image: url("~assets/img/joinus/post2-hover.png");
            }
          }
        }
      }

      &:nth-of-type(3) {
        .conditions {
          div.icon {
            background-image: url("~assets/img/joinus/post3.png");
          }

          &:hover {
            div.icon {
              background-image: url("~assets/img/joinus/post3-hover.png");
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 992px) {
    .main {
      .title {
        font-size: 20px;

        &::before,
        &::after {
          background: unset;
        }
      }
    }

    .details {
      .box {
        .conditions {
          padding: 13% 0;
          font-size: 16px;

          div.icon {
            margin-bottom: unset;
            width: unset;
            height: unset;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .details {
      .box {
        .conditions {
          padding: 10% 0;
          font-size: 13px;
        }
      }
    }
  }
</style>
